import { ViewBooking, ViewBookingStatusEnum } from "collins-js-sdk";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { BookingLabelsEnum } from "../types/bookingEnums";
import { getTimeFromString } from "./booking";

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(isBetween);

export const completeBookingsFilter = (booking: ViewBooking) =>
  booking.status === "complete" &&
  booking.currentStage != "left" &&
  (booking.actualGuests ?? 0) > 0;

export const leftBookingsFilter = (booking: ViewBooking) =>
  (booking.currentStage === "left" || booking.actualGuests === 0) &&
  booking.status !== ViewBookingStatusEnum.Rejected;

export const waitlistBookingsFilter = (booking: ViewBooking) =>
  (booking.status === "in_progress" || booking.status === "new") &&
  booking.waitlisted &&
  booking.currentStage !== "left" &&
  booking.currentStage !== "no-show" &&
  booking.actualGuests !== 0;

export const openBookingsFilter = (booking: ViewBooking) =>
  (booking.status === "in_progress" || booking.status === "new") &&
  !booking.waitlisted &&
  booking.currentStage != "left";

export const morningFilter = (booking: ViewBooking) =>
  booking.time &&
  dayjs(getTimeFromString(booking.time)).isSameOrBefore(
    dayjs().hour(11).minute(59)
  );

export const afternoonFilter = (booking: ViewBooking) =>
  booking.time &&
  dayjs(getTimeFromString(booking.time)).isSameOrAfter(
    dayjs().hour(12).minute(0)
  ) &&
  dayjs(getTimeFromString(booking.time)).isSameOrBefore(
    dayjs().hour(15).minute(59)
  );

export const eveningFilter = (booking: ViewBooking) =>
  booking.time &&
  dayjs(getTimeFromString(booking.time)).isSameOrAfter(
    dayjs().hour(16).minute(0)
  ) &&
  dayjs(getTimeFromString(booking.time)).isBefore(dayjs().hour(23).minute(59));

export const autoConfirmedFilter = (booking: ViewBooking) =>
  !!booking.autoConfirmed;

export const customerRequestsFilter = (booking: ViewBooking) =>
  booking.labels?.[0] === BookingLabelsEnum.PackagesRequested;

export const runSheetNotesFilter = (booking: ViewBooking) =>
  booking.comments?.length !== 0;

export const doubleConfirmedFilter = (booking: ViewBooking) =>
  booking.doubleConfirmed;

export const notDoubleConfirmedFilter = (booking: ViewBooking) =>
  !booking.doubleConfirmed;

export const collinsCallChanneFilter = (booking: ViewBooking) =>
  booking.channel === "collins-call";
